<template>
  <div class="pay-page-root">
    <div class="center-layout">
      <!-- 左侧侧边栏 -->
      <div class="account-layout">
        <AccountSidebar activeMenu="paymentMethods" :titleName="t('payment.title')" />
      </div>
      <div class="order-content">
        <!-- 面包屑放这里 -->
        <nav class="breadcrumb">
          <router-link
            to="/"
            class="breadcrumb-link"
          >{{ t('header.home') }}</router-link>
          <template v-if="route.name === 'PaymentMethodList'">
            <span class="breadcrumb-sep">&gt;</span>
            <span class="breadcrumb-current">
              {{ t('payment.paymentMethodList') }}
            </span>
          </template>
          <template v-else-if="route.name === 'PaymentMethod'">
            <span class="breadcrumb-sep">&gt;</span>
            <router-link
              :to="{ name: 'PaymentMethodList' }"
              class="breadcrumb-link"
            >{{ t('payment.paymentMethodList') }}</router-link>
            <span class="breadcrumb-sep">&gt;</span>
            <span class="breadcrumb-current">
              {{ t('payment.title') }}
            </span>
          </template>
        </nav>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script setup>
import AccountSidebar from '@/views/PersonCenter/AccountSidebar.vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const route = useRoute()
</script>

<style scoped>
.pay-page-root {
  display: flex;
  min-height: 100vh;
  background: #f5f7fa;
}
.center-layout {
   display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  gap: 18px;
  padding-top: 18px;
}
.account-layout {
   margin-bottom: 16px;
    margin-left: 0;
    min-width: 0;
}
.order-content {
  flex: 1;

 
}
.breadcrumb-link {
  color: #fb6e01;
  text-decoration: none;
  font-weight: 500;
}
.breadcrumb-link:hover {
  text-decoration: underline;
}
.breadcrumb-sep {
  margin: 0 6px;
  color: #888;
}
.breadcrumb-current {
  color: #4a5568;
  font-weight: 500;
}
@media (max-width: 800px) {
  .center-layout {
    flex-direction: column;
    gap: 0;
    padding-top: 0;
    max-width: 100vw;
  }
  .account-layout {
    margin-bottom: 10px;
    margin-left: 12px;
    margin-top: 16px;
    min-width: 0;
  }
  .order-content {
    width: 100vw;
  max-width: 100vw;
  min-width: 0;
  padding: 12px 10px;
  box-sizing: border-box;
  border-radius: 10px;
  margin: 0;
    
  }
}
</style>